import { render, staticRenderFns } from "./apiShapeList.vue?vue&type=template&id=7454e79a&scoped=true&"
import script from "./apiShapeList.vue?vue&type=script&lang=js&"
export * from "./apiShapeList.vue?vue&type=script&lang=js&"
import style0 from "./apiShapeList.vue?vue&type=style&index=0&id=7454e79a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7454e79a",
  null
  
)

export default component.exports